export enum Types {
  AUTHENTICATE = "AUTHENTICATION_AUTHENTICATE",
  AUTHENTICATE_SUCCESS = "AUTHENTICATION_AUTHENTICATE_SUCCESS",
  AUTHENTICATE_FAIL = "AUTHENTICATION_FAIL",
  LOGOUT = "AUTHENTICATION_LOGOUT",
  LOGOUT_SUCCESS = "AUTHENTICATION_LOGOUT_SUCCESS",
  LOGOUT_FAIL = "AUTHENTICATION_LOGOUT_FAIL",
}

export type Action =
  | AuthenticateAction
  | AuthenticateSuccessAction
  | AuthenticateFailAction
  | LogoutAction
  | LogoutSuccessAction
  | LogoutFailAction

export type LogoutAction = {
  type: Types.LOGOUT
}

export type LogoutSuccessAction = {
  type: Types.LOGOUT_SUCCESS
}

export type LogoutFailAction = {
  type: Types.LOGOUT_FAIL
  payload: { errors: object }
}

export type AuthenticateAction = {
  type: Types.AUTHENTICATE
}

export type AuthenticateSuccessAction = {
  type: Types.AUTHENTICATE_SUCCESS
}

export type AuthenticateFailAction = {
  type: Types.AUTHENTICATE_FAIL
  payload: { errors: object }
}

export function authenticate(): AuthenticateAction {
  return {
    type: Types.AUTHENTICATE,
  }
}

export function authenticateSuccess(): AuthenticateSuccessAction {
  return {
    type: Types.AUTHENTICATE_SUCCESS,
  }
}

export function authenticateFail(errors: object): AuthenticateFailAction {
  return {
    payload: { errors },
    type: Types.AUTHENTICATE_FAIL,
  }
}

export function logout(): LogoutAction {
  return {
    type: Types.LOGOUT,
  }
}

export function logoutSuccess(): LogoutSuccessAction {
  return {
    type: Types.LOGOUT_SUCCESS,
  }
}

export function logoutFail(errors: object): LogoutFailAction {
  return {
    payload: { errors },
    type: Types.LOGOUT_FAIL,
  }
}
